export const COMMUNITY_SLACK_URL =
  "https://join.slack.com/t/chalkcommunity/shared_invite/zt-4dd80m1w5-D8Dd8oMMfaOCUFCpQm9IRQ";
